import moment from "moment";

// Components
import { toastStore } from "../components/Toast/Store";

import UUID from "../utils/GenerateUUID";

const baseAction = "NOTIFICATIONS";

export function CleanNotifications(notificationId) {
	return (dispatch, getState) => {
		/*
            this filters out any notifications that have a createdAt
            time greater than their timeToLive value. I had a 50
            millisecond factor of safety to it.
        */

		const now = moment();
		const currentState = getState();

		const newActiveList = currentState.notifications.get("active").filter((notification) => {
			if (now.diff(notification.get("createdAt")) >= notification.get("timeToLive") - 50) {
				return false;
			} else if (notification.get("id") === notificationId) {
				return false;
			}

			return true;
		});

		dispatch({
			type: `${baseAction}:UPDATE`,
			notifications: newActiveList,
		});
	};
}

export function DisplayError(message) {
	return () => {
		toastStore.getState().addToast({
			message,
			type: "error",
		});
	};
}

export const displayWarning = (message) => () => {
	toastStore.getState().addToast({
		message,
		type: "warning",
	});
};

export const Toast =
	(message, action, timeToLive = 5000) =>
	(dispatch) => {
		const id = UUID();

		dispatch({
			type: `${baseAction}:TOAST`,
			clickAction: action,
			notificationId: id,
			notificationType: "toast",
			ttl: timeToLive,
			message,
		});

		if (timeToLive) {
			setTimeout(() => {
				dispatch(CleanNotifications());
			}, timeToLive);
		}
	};

export function DisplaySuccess(message) {
	return () => {
		toastStore.getState().addToast({
			message,
			type: "success",
		});
	};
}

export function DisplayCheckbox(time = 1000) {
	return () => {
		/*
            This is the old checkbox success notification.
        */

		if (window.Success) {
			window.Success({ time });
		}
	};
}

export function DisplayUndo(message, undoCallback) {
	return (dispatch) => {
		const id = UUID();
		const timeToLive = 10000;

		// write a new undo callback that removes the notification
		// when it's executed.
		const newUndoCallback = () => {
			undoCallback();
			dispatch(CleanNotifications(id));
		};

		dispatch({
			type: `${baseAction}:UNDO`,
			notificationId: id,
			notificationType: "undo",
			ttl: timeToLive,
			undoCallback: newUndoCallback,
			message,
		});

		setTimeout(() => {
			dispatch(CleanNotifications());
		}, timeToLive);
	};
}
